module.exports = __webpack_public_path__ + "img/mk-地理@2x.35e27f6b.png";